export const DOCUMENTATION_SUBJECT = 'Documentación';

export const QUOTE = 'Quote';
export const TECHNICAL_SHEET = 'TechnicalSheet';
export const CREDITS_REQUIREMENTS = 'CreditsRequirements';
export const MAINTENANCE_COSTS = 'MaintenanceCosts';
export const LOCATION = 'Location';
export const GALLERY_VERSIONS = 'GalleryVersions';
export const CREDIT_REQUEST = 'CreditRequest';
export const CATALOGUE = 'Catalogue';
export const PURCHASE_BENEFITS = 'PurchaseBenefits';
export const EVENT = 'Event';

export const DOCUMENTATION_TITLES = [
    QUOTE,
    TECHNICAL_SHEET,
    CREDITS_REQUIREMENTS,
    MAINTENANCE_COSTS,
    LOCATION,
    GALLERY_VERSIONS,
    CREDIT_REQUEST,
    CATALOGUE,
    PURCHASE_BENEFITS,
    EVENT,
];
